import { CredentialType } from '#/components/ethereum/credential-type';
import { Timestamp } from '#/components/timestamp';
import { EthereumStakingValidatorInfo } from '#/data/react-query/queries/order-list';
import { ValidatorStatus } from '#/modules/display/validator-status';
import { Translation } from 'intl-lib';
import { ValidatorIndex } from './validator-index';

type Props = {
  item: EthereumStakingValidatorInfo;
};

export function ValidatorRow({ item }: Props) {
  return (
    <div role="table" className="flex flex-col text-sm">
      <div
        role="rowgroup"
        className="h-12 px-4 bg-slate-200 rounded-lg font-medium text-slate-600"
      >
        <div
          role="row"
          className="grid grid-cols-5 items-center bg-slate-200 hover:bg-slate-200 h-12"
        >
          <div role="columnheader">
            <Translation path="my_staking.order.validator_column.validator" />
          </div>
          <div role="columnheader">
            <Translation path="my_staking.order.validator_column.credential_type" />
          </div>
          <div role="columnheader">
            <Translation path="my_staking.order.validator_column.balance" />
          </div>
          <div role="columnheader">
            <Translation path="my_staking.order.validator_column.last_update" />
          </div>
          <div role="columnheader">
            <Translation path="my_staking.order.validator_column.status" />
          </div>
        </div>
      </div>
      <div role="rowgroup" className="flex flex-col gap-2">
        <div role="row" className="h-13 px-4 grid grid-cols-5 items-center">
          <div role="cell">
            <ValidatorIndex
              validatorIndex={item.validatorIndex}
              publicKey={item.pubKey}
            />
          </div>
          <div role="cell">
            <CredentialType credentialType={item.credentialType} />
          </div>
          <div role="cell">{item.effectiveBalance} ETH</div>
          <div role="cell" className="truncate">
            <Timestamp date={item.lastUpdate} toggleable />
          </div>
          <div role="cell">
            <ValidatorStatus item={item} />
          </div>
        </div>
      </div>
    </div>
  );
}
